import { render, staticRenderFns } from "./formedModal.vue?vue&type=template&id=a057507c&scoped=true&"
import script from "./formedModal.vue?vue&type=script&lang=js&"
export * from "./formedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a057507c",
  null
  
)

export default component.exports